import { render, staticRenderFns } from "./BrokerageNoteRow.vue?vue&type=template&id=4048f4d3&scoped=true&"
import script from "./BrokerageNoteRow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BrokerageNoteRow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BrokerageNoteRow.vue?vue&type=style&index=0&id=4048f4d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048f4d3",
  null
  
)

export default component.exports